import React from 'react';
import './ImagePreview.css';

import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import StarRateIcon from '@material-ui/icons/StarRate';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

class ImagePreview extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false
    };
  }

  toggleDropdown = (e) => {
    this.setState((state) => {
      return {showDropdown: !state.showDropdown };
    }, this.focus)
  }

  focus = () => {
    const element = document.getElementById("list");
    if(element) {
      element.focus();
    }
  }

  handleClickOutside = () => {
    this.setState({ showDropdown: false });
  }

  displayImageOptions = () => {
    const { imageId, onSetAsCover, onDownloadImage, onDeleteImage, photo } = this.props;

    return (
      <ul id='list' tabIndex="0" onBlur={this.handleClickOutside} className="anchor-gallery-image-options" style={{zIndex: '99999'}}>
        <li 
          className="anchor-gallery-image-options__action" 
          onClick={() => onSetAsCover(imageId)}>
            <StarRateIcon /> Set as cover
        </li>
        <li 
          className="anchor-gallery-image-options__action" 
          onClick={() => onDownloadImage(photo.src)}>
            <ArrowDownwardIcon /> Download
        </li>
        <li 
          className="anchor-gallery-image-options__action" 
          onClick={() => onDeleteImage(imageId)}>
            <DeleteForeverIcon /> Delete
        </li>
      </ul>
    )
  }

  render() {
    const { margin, photo, left, top, direction, openLightbox, index } = this.props;
    const { showDropdown } = this.state;

    const additionalStyles = {
      backgroundColor: "#eee",
      cursor: "pointer",
      overflow: "hidden",
      position: "relative"
    };

    if (direction === "column") {
      additionalStyles.position = "absolute";
      additionalStyles.left = left;
      additionalStyles.top = top;
    }
    
    return (
      <div
        style={{display: 'flex', flexFlow: 'row wrap'}}
        className="anchor-gallery-image-wrapper">

        <div 
          onClick={() => openLightbox(index)}
          className="anchor-gallery-image" 
          style={{ 
            margin, height: photo.height, 
            width: photo.width, 
            ...additionalStyles, 
            background: `url(${photo.src}) no-repeat center center / cover` }} >
        </div>
        <div onClick={this.toggleDropdown} className="ancor-gallery-edit-image">
          <MoreHorizIcon fontSize="large" />  
        </div>
        {
          showDropdown &&
          this.displayImageOptions()
        }
      </div>
    )
  }
}

export default ImagePreview;
